/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Globalsearch_Semantic_Error1Inputs */

const id_globalsearch_semantic_error1 = /** @type {(inputs: Globalsearch_Semantic_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kecocokan berdasarkan makna tidak dapat dimuat.`)
};

const ms_globalsearch_semantic_error1 = /** @type {(inputs: Globalsearch_Semantic_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Padanan mengikut makna tidak dapat dimuatkan.`)
};

const da_globalsearch_semantic_error1 = /** @type {(inputs: Globalsearch_Semantic_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunne ikke indlæse matcher efter betydning.`)
};

const de_globalsearch_semantic_error1 = /** @type {(inputs: Globalsearch_Semantic_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treffer nach Bedeutung konnten nicht geladen werden.`)
};

const en_us2_globalsearch_semantic_error1 = /** @type {(inputs: Globalsearch_Semantic_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not load matches by meaning.`)
};

const es_es2_globalsearch_semantic_error1 = /** @type {(inputs: Globalsearch_Semantic_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudieron cargar las coincidencias por significado.`)
};

const es_mx2_globalsearch_semantic_error1 = /** @type {(inputs: Globalsearch_Semantic_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudieron cargar las coincidencias por significado.`)
};

const fil_globalsearch_semantic_error1 = /** @type {(inputs: Globalsearch_Semantic_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi ma-load ang mga tugma ayon sa kahulugan.`)
};

const fr_globalsearch_semantic_error1 = /** @type {(inputs: Globalsearch_Semantic_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de charger les correspondances par sens.`)
};

const it_globalsearch_semantic_error1 = /** @type {(inputs: Globalsearch_Semantic_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile caricare le corrispondenze per significato.`)
};

const hu_globalsearch_semantic_error1 = /** @type {(inputs: Globalsearch_Semantic_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A jelentés szerinti találatok nem tölthetők be.`)
};

const nl_globalsearch_semantic_error1 = /** @type {(inputs: Globalsearch_Semantic_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overeenkomsten op betekenis konden niet worden geladen.`)
};

const no_globalsearch_semantic_error1 = /** @type {(inputs: Globalsearch_Semantic_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunne ikke laste inn treff etter betydning.`)
};

const pl_globalsearch_semantic_error1 = /** @type {(inputs: Globalsearch_Semantic_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie udało się załadować dopasowań według znaczenia.`)
};

const pt_br2_globalsearch_semantic_error1 = /** @type {(inputs: Globalsearch_Semantic_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível carregar as correspondências por significado.`)
};

const pt_globalsearch_semantic_error1 = /** @type {(inputs: Globalsearch_Semantic_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível carregar as correspondências por significado.`)
};

const ro_globalsearch_semantic_error1 = /** @type {(inputs: Globalsearch_Semantic_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potrivirile după sens nu au putut fi încărcate.`)
};

const fi_globalsearch_semantic_error1 = /** @type {(inputs: Globalsearch_Semantic_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merkityksen perusteella löytyviä osumia ei voitu ladata.`)
};

const sv_globalsearch_semantic_error1 = /** @type {(inputs: Globalsearch_Semantic_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Det gick inte att läsa in matchningar efter betydelse.`)
};

const vi_globalsearch_semantic_error1 = /** @type {(inputs: Globalsearch_Semantic_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không thể tải kết quả khớp theo ý nghĩa.`)
};

const tr_globalsearch_semantic_error1 = /** @type {(inputs: Globalsearch_Semantic_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anlama göre eşleşmeler yüklenemedi.`)
};

const cs_globalsearch_semantic_error1 = /** @type {(inputs: Globalsearch_Semantic_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shody podle významu se nepodařilo načíst.`)
};

const bg_globalsearch_semantic_error1 = /** @type {(inputs: Globalsearch_Semantic_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Съвпаденията по смисъл не могат да бъдат заредени.`)
};

const ru_globalsearch_semantic_error1 = /** @type {(inputs: Globalsearch_Semantic_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось загрузить совпадения по смыслу.`)
};

const uk_globalsearch_semantic_error1 = /** @type {(inputs: Globalsearch_Semantic_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не вдалося завантажити збіги за значенням.`)
};

const ar_globalsearch_semantic_error1 = /** @type {(inputs: Globalsearch_Semantic_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تعذّر تحميل المطابقات حسب المعنى.`)
};

const hi_globalsearch_semantic_error1 = /** @type {(inputs: Globalsearch_Semantic_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अर्थ के आधार पर मिलान लोड नहीं हो सके।`)
};

const th_globalsearch_semantic_error1 = /** @type {(inputs: Globalsearch_Semantic_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่สามารถโหลดรายการที่ตรงกันตามความหมายได้`)
};

const ja_globalsearch_semantic_error1 = /** @type {(inputs: Globalsearch_Semantic_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`意味による一致を読み込めませんでした。`)
};

const zh_cn2_globalsearch_semantic_error1 = /** @type {(inputs: Globalsearch_Semantic_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无法加载按含义匹配的结果。`)
};

const zh_hant1_globalsearch_semantic_error1 = /** @type {(inputs: Globalsearch_Semantic_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無法載入依意義相符的結果。`)
};

const ko_globalsearch_semantic_error1 = /** @type {(inputs: Globalsearch_Semantic_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`의미별 일치 항목을 불러오지 못했습니다.`)
};

/**
* | output |
* | --- |
* | "Could not load matches by meaning." |
*
* @param {Globalsearch_Semantic_Error1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const globalsearch_semantic_error1 = /** @type {((inputs?: Globalsearch_Semantic_Error1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Globalsearch_Semantic_Error1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_globalsearch_semantic_error1(inputs)
	if (locale === "ms") return ms_globalsearch_semantic_error1(inputs)
	if (locale === "da") return da_globalsearch_semantic_error1(inputs)
	if (locale === "de") return de_globalsearch_semantic_error1(inputs)
	if (locale === "en-US") return en_us2_globalsearch_semantic_error1(inputs)
	if (locale === "es-ES") return es_es2_globalsearch_semantic_error1(inputs)
	if (locale === "es-MX") return es_mx2_globalsearch_semantic_error1(inputs)
	if (locale === "fil") return fil_globalsearch_semantic_error1(inputs)
	if (locale === "fr") return fr_globalsearch_semantic_error1(inputs)
	if (locale === "it") return it_globalsearch_semantic_error1(inputs)
	if (locale === "hu") return hu_globalsearch_semantic_error1(inputs)
	if (locale === "nl") return nl_globalsearch_semantic_error1(inputs)
	if (locale === "no") return no_globalsearch_semantic_error1(inputs)
	if (locale === "pl") return pl_globalsearch_semantic_error1(inputs)
	if (locale === "pt-BR") return pt_br2_globalsearch_semantic_error1(inputs)
	if (locale === "pt") return pt_globalsearch_semantic_error1(inputs)
	if (locale === "ro") return ro_globalsearch_semantic_error1(inputs)
	if (locale === "fi") return fi_globalsearch_semantic_error1(inputs)
	if (locale === "sv") return sv_globalsearch_semantic_error1(inputs)
	if (locale === "vi") return vi_globalsearch_semantic_error1(inputs)
	if (locale === "tr") return tr_globalsearch_semantic_error1(inputs)
	if (locale === "cs") return cs_globalsearch_semantic_error1(inputs)
	if (locale === "bg") return bg_globalsearch_semantic_error1(inputs)
	if (locale === "ru") return ru_globalsearch_semantic_error1(inputs)
	if (locale === "uk") return uk_globalsearch_semantic_error1(inputs)
	if (locale === "ar") return ar_globalsearch_semantic_error1(inputs)
	if (locale === "hi") return hi_globalsearch_semantic_error1(inputs)
	if (locale === "th") return th_globalsearch_semantic_error1(inputs)
	if (locale === "ja") return ja_globalsearch_semantic_error1(inputs)
	if (locale === "zh-CN") return zh_cn2_globalsearch_semantic_error1(inputs)
	if (locale === "zh-Hant") return zh_hant1_globalsearch_semantic_error1(inputs)
	return ko_globalsearch_semantic_error1(inputs)
});
export { globalsearch_semantic_error1 as "globalSearch.semantic.error" }